import React from 'react';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';

const Privacy = () => {
  const sections = [
    {
      title: '1. Données collectées',
      content: (
        <div>
          <p className="mb-3">IPTV4KFR collecte uniquement les données nécessaires à :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>La création des comptes</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>La gestion des abonnements</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>Le suivi des ventes et commissions</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>L'amélioration de l'expérience utilisateur</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '2. Types de données',
      content: (
        <div>
          <p className="mb-3">Peuvent être collectées :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Nom</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Email</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Informations de connexion</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Données de navigation anonymisées</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '3. Utilisation des données',
      content: (
        <div>
          <p className="mb-3">Les données sont utilisées exclusivement pour :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>Le fonctionnement de la plateforme</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>La communication avec les utilisateurs</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>La gestion des services proposés</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '4. Confidentialité',
      content: (
        <div className="bg-[#00FF88]/10 border border-[#00FF88]/30 p-4 rounded-lg">
          <p className="text-[#00FF88] font-semibold">
            Les données ne sont ni vendues, ni cédées à des tiers non autorisés.
          </p>
        </div>
      )
    },
    {
      title: '5. Sécurité',
      content: 'Des mesures techniques et organisationnelles sont mises en place pour protéger les données contre tout accès non autorisé.'
    },
    {
      title: '6. Droits des utilisateurs',
      content: (
        <div>
          <p className="mb-3">Chaque utilisateur peut :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Accéder à ses données</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Demander leur modification</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Demander leur suppression</span>
            </li>
          </ul>
          <p className="mt-3 text-[#B8B8BA]">Les demandes s'effectuent via les moyens de contact indiqués sur le site.</p>
        </div>
      )
    },
    {
      title: '7. Cookies',
      content: 'Des cookies peuvent être utilisés afin d\'améliorer l\'expérience de navigation. L\'utilisateur peut gérer ses préférences depuis son navigateur.'
    }
  ];

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-block p-4 bg-[#00FFFF]/10 rounded-full mb-6">
            <Lock className="h-12 w-12 text-[#00FFFF]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Politique de confidentialité
          </h1>
          <p className="text-[#B8B8BA]">
            Protection et utilisation de vos données personnelles
          </p>
        </motion.div>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * index }}
              className="bg-gradient-to-br from-[#1A1A1D] to-[#121214] p-6 rounded-xl border border-white/10"
            >
              <h2 className="text-xl font-bold text-white mb-3">
                {section.title}
              </h2>
              <div className="text-[#E8E8E8] leading-relaxed">
                {section.content}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 bg-[#00FF88]/10 border border-[#00FF88]/30 p-6 rounded-xl text-center"
        >
          <Lock className="h-8 w-8 text-[#00FF88] mx-auto mb-3" />
          <p className="text-white font-semibold mb-2">
            Vos données sont protégées
          </p>
          <p className="text-[#B8B8BA] text-sm">
            IPTV4KFR s'engage à respecter votre vie privée et à sécuriser vos informations personnelles.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;
